export default {
  SET_sophiaText(state, value) {
    state.sophiaText = value;
  },
  SET_searchType(state, value) {
    state.searchType = value;
  },
};
